// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"w5-z","dimensionLabel":"x5-z","styleChooserControlWrapper":"y5-z","styleChooserControl":"z5-z","disabled":"A5-z","giftCard":"B5-z","styleChooserText":"C5-z"};